export interface IDispensingOrdersState {
    customerId: number | null;
    dispensingOrderFuels: Array<IDispensingOrder> | [];
    dispensingOrders: Array<IDispensingOrder>;
    loading: boolean;
    viewState: DispensingOrdersViewState;
    fuelStock: DispensingOrdersFuelsStock;
    editingDispensingOrder?: IDispensingOrder;
}

export interface IDispensingOrdersFormProps {
    fuelStock: DispensingOrdersFuelsStock;
    editingDispensingOrder?: IDispensingOrder;
    viewState: DispensingOrdersViewState;
    onFuelStockChange: (viewState: DispensingOrdersFuelsStock) => void;
    onSubmitReload: () => void;
}

export interface IDispensingOrdersFormState {
    customerId: number | null;
    dispensingOrderFuels: Array<IDispensingOrderFuel>;
    carriers: Array<Carrier>;
    cars: Array<Car>;
    drivers: Array<Driver>;
    form: IDispensingOrderForm;
    isSubmittingModalOpen: boolean;
    loading: boolean;
    validated: boolean;
}

export interface IDispensingOrderForm {
    documentNumber: string;
    owner: 'TT' | 'ORL' | 'ALEXELA' | 'OLE' | '';
    ownerLabel: string;
    carrier: string;
    carrierLabel: string;
    car: string;
    carLabel: string;
    driver: string;
    driverLabel: string;
    validUntil: string;
    validUntilDate: Date | undefined;
}

export interface IDispensingOrder {
    authorizationNumber: string;
    carCode: string;
    carRegNumber: string;
    customerCode: string;
    customerName: string;
    documentStateCode: string;
    documentStateName: string;
    driverCode: string;
    driverName: string;
    isModifiable: string;
    productOwnerName: string;
    remoteId: number;
    remoteObjectId: string;
    remoteProductOwnerId: number;
    trailerRegNumber: string;
    transporterCode: string;
    transporterName: string;
    uid: string;
    validUntil: string;
    productRows: Array<IIDispensingOrderProductRow>
}

export interface IIDispensingOrderProductRow {
    productName: string;
    quantity: number
    remoteBatchId: number
    rowNumber: number
}

export interface IDispensingOrderFuel {
    remoteProductId: number;
    quantity: number;
    productName: string;
    remoteBatchId: string;
    bestBeforeDate: string;
    tank: string;
    type: string;
    orlenCode: string;
    remoteStockId: string;
    remoteDosBatchId: string | null;

    isDosVisible: boolean;
    isSelected: boolean;
    batchAmount: number | string;
    dosBatchAmount: number | string;
}

export interface Driver {
    code: string,
    name: string,
    personalCode: string
}

export interface Carrier {
    id: number;
    searchCode: string;
    name: string;
    registryCode: string;
}

export interface Car {
    code: string;
    name: string;
}
export interface CarGroup {
    code: string,
    plateNumber: string,
    trailers: Array<Trailer>
}

export interface Trailer {
    code: string,
    trailerNumber: string,
}

export interface IDispensingOrdersSearchBarState {
    viewState: DispensingOrdersViewState
    fuelStock: DispensingOrdersFuelsStock
}

export interface IDispensingOrdersSearchBarProps {
    viewState: DispensingOrdersViewState
    onViewChange: (viewState: DispensingOrdersViewState) => void
    onFuelStockChange: (viewState: DispensingOrdersFuelsStock) => void
}

export enum DispensingOrdersViewState {
    NEW,
    EDIT,
    VIEW
}
export enum DispensingOrdersFuelsStock {
    EXCISE = "EXCISE", // 33
    COMMERCIAL = "COMMERCIAL" // 1
}

export interface IDispensingOrderRequestForm {
    documentNumber: string;
    owner: 'TT' | 'ORL' | 'ALEXELA' | 'OLE' | '';
    carrier: string;
    vehicleCode: string;
    driver: string;
    validUntil: string;
    warehouse: DispensingOrdersFuelsStock;
    rows: Array<IDispensingOrderRequestRow>
}
export interface IDispensingOrderRequestRow {
    batchAmount: number;
    remoteBatchId: number;
    dosBatchAmount: number;
    remoteDosBatchId: number;
}
export interface ISavingProgress {
    uid: string;
    message: string;
    state: "RUNNING" | "COMPLETED" | "FAILED";
}

export interface IDispensingOrderEditRequestForm {
    uid: string;
    documentNumber: string;
    owner: 'TT' | 'ORL' | 'ALEXELA' | 'OLE' | '';
    carrier: string;
    vehicleCode: string;
    driver: string;
    validUntil: string;
    warehouse: DispensingOrdersFuelsStock;
    newRows: Array<IDispensingOrderRequestRow>
    modifiedRows: Array<IDispensingOrderModifiedFuelRequestRow>
}

export interface IDispensingOrderModifiedFuelRequestRow {
    rowNumber: number;
    productName: string;
    quantity: number;
}
